
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";
import { useForm } from "react-hook-form";
import { notifySuccess, notifyWarn } from "../services/Toastifyfn";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import debounce from "lodash.debounce";
import { isMobile } from 'react-device-detect';
import { Tooltip } from 'react-tooltip'
import axios from "axios";
// lsq start

import {
  callLSQLapp,
  getLsqLeadBody,
  getFirstNameLastName,
  getScores,
  encryptBody,
} from "../services/lsq.js";
import { useCookies } from "react-cookie";
import queryString from "query-string";
import "../App.css";
// import { companyList } from "../services/compData.js";
import { formatAndValidateE164, hashValue, normalizeEmail, setValuesInLocalStorange } from "../services/utils.js";
import {
  eventClick,
  eventWithFormInfo,
  fieldErrorEvent,
  formAbandonEvent,
  formIntermediateEventOTP,
  formStarts,
  formSubmissionFailEvent,
  formSubmitEvent,
  resendOTPEvent,
  submitErrorEvent,
} from "../services/adobeDataLayer.js";
// lsq end

function Form({ customADL, setCustomADL }) {
  let navigate = useNavigate();
  const [fullName, setfullname] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [workEmail, setworkEmail] = useState("");
  const [mobileNo, setmobileno] = useState("");
  const [pincode, setpincode] = useState("");
  const [city, setcity] = useState("");
  const [otp1, setotp1] = useState("");
  const [otp2, setotp2] = useState("");
  const [otp3, setotp3] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [otp4, setotp4] = useState("");
  const [otp5, setotp5] = useState("");
  const [otp6, setotp6] = useState("");
  const [otpStatus, setOtpStatus] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [Terms, setTerms] = useState(false);
  const [pan, setpan] = useState("");
  const [panNum, setPanNum] = useState("");
  // const [caseID, setCaseID] = useState("")

  // lsq
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [token, setToken] = useState("");
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);
  const [OTPVal, setOTPValue] = useState("");
  const [inputs, setInputs] = useState({ User_Agent: navigator.userAgent });
  const [options, setOptions] = useState([]);
  const [solId, setSolid] = useState("");

  const lastAccessedField = useRef("");
  const validPincodeRef = useRef(null); // null=unchecked, true=valid, false=invalid

  const [companies, setCompanies] = useState([]);
  const [topCorporate, settopCorporate] = useState("");
  const [otherCompanyName, setOtherCompanyName] = useState("")
  const [gcc, setGcc] = useState("")




  const [enableMail, setEnableMail] = useState(false);
  // const [emailVerified, setEmailVerified] = useState(false);
  const [customCompany, setCustomCompany] = useState(false);
  // const [accountType, setAccountType] = useState("Salary Account");
  const [showDropdown, setShowDropdown] = useState(true);

  const [journeyType, setJourneyType] = useState("Savings Account");
  const [formStarted, setFormStarted] = useState(false);
  const [showOtherInput, setShowOtherInput] = useState(false);



  const errorRef = useRef({});

  let cancelToken;


  useEffect(() => {
    let retryCount = 0; // Initialize retry counter
    const maxRetries = 5; // Maximum retries
    const retryInterval = 4000; // Interval between retries in ms

    const getCookieValue = (cookieName) => {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName))
        ?.split("=")[1];
    };

    const captureCookies = () => {
      const fbpValue = getCookieValue("_fbp") || "";
      const fbcValue = getCookieValue("_fbc") || "";

      setFbp(fbpValue);
      setFbc(fbcValue);

      // Check if retries are needed
      if ((!fbpValue || !fbcValue) && retryCount < maxRetries) {
        retryCount++;
        setTimeout(captureCookies, retryInterval); // Retry after the interval
      }
    };

    captureCookies(); // Start capturing cookies on mount
  }, []);

  // Adobe Effect
  useEffect(() => {
    // console.log(customADL,"custo,ADL")
    if (customADL.formStarts && customADL.cta) {
      if (customADL.formStarts < customADL.cta) {
        // console.log("formAbandon")
        formAbandonEvent(lastAccessedField.current);
        setCustomADL({ ...customADL, formStarts: "" });
      }
    }
  }, [customADL]);



  useEffect(() => {
  }, [employerName]);



  const handleRightCLickTC = (e) => {
    e.preventDefault();
    eventClick("terms and conditions", "link", "form");
  };

  const [Validtionerrors, setErrors] = useState({
    fullnameerror: { error: false, message: "", type: "" },
    employerNameerror: { error: false, message: "", type: "" },
    workEmailerror: { error: false, message: "", type: "" },
    mobilenoerror: { error: false, message: "", type: "" },
    pincodeerror: { error: false, message: "", type: "" },
    cityerror: { error: false, message: "", type: "" },
    otperror: { error: false, message: "", type: "" },
    termserror: { error: false, message: "", type: "" },
    panerror: { error: false, message: "", type: "" },
    othercompanyerror: { error: false, message: "", type: "" },
    incomeerror: { error: false, message: "", type: "" },
  });

  // useEffect(() => {
  //   console.log(Validtionerrors,"errorsobj")
  // },[Validtionerrors])


  const selectStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      fontSize: "13px",
      color: "black",
      borderTop: 0,
      borderRight: 0,
      borderLeft: 0,
      borderRadius: 0,
    }),
    placeholder: (baseStyles, state) => ({
      ...baseStyles,
      color: "black",
    }),
  };

  const Onsetterms = (e) => {
    handleChange(e)
    setTerms(e.target.checked);
    eventWithFormInfo(
      "terms & conditions",
      "checkbox",
      "form",
      "",
      inputs
    );
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    resetField,
    watch,
  } = useForm();
  const annualIncome = watch("annualIncome");
  const sendOtp = async (type) => {
    if (!mobileNo) {
      if (mobileNo === "" || mobileNo == undefined) {
        setErrors({
          mobilenoerror: {
            error: true,
            message: "Please enter mobile no",
            type: "required",
          },
        });
        fieldErrorEvent("Please enter mobile no.", "mobile");
        return false;
      } else {
        setErrors({
          mobilenoerror: {
            error: false,
            message: "Please enter mobile no",
            type: "required",
          },
        });
      }
    }
    if (mobileNo.length === 10) {
      try {
        if (type !== "resend") {
          let otpType = type === "resend" ? "resend" : "send";
          formIntermediateEventOTP(otpType)
        } else if (type === "resend") {
          eventWithFormInfo("resend", "button", "form", "", inputs);
        }

        let payload = { mobile: mobileNo, messageType: "otpGeneral" };
        let param = { otp: "send", productType: "BG", autoReadOtp: "yes" };
        const otpResponse = await callLSQLapp(payload, "OTP", param);
        // const res = await onSendOtp(mobileNo);
        if (otpResponse.data.message.response.sent) {
          notifySuccess("OTP has been sent to your mobile number.");
          setOtpStatus(true);
          setSeconds(60);
          await mainFun(mobileNo);
        } else if (otpResponse.data.message.response === "MAX OTP Limit reached") {
          window.alert("OTP Limit reached, try again after 5 minutes");
          window.location.reload();
        }
        else {
          notifyWarn("Please Resend OTP.");
          setSeconds(60);
        }
      } catch (error) {
        alert(
          "Error occurred while generating OTP. please Refresh the page and try again"
        );
      }
    }
  };

  const mainFun = async (mobile) => {
    if ("OTPCredential" in window) {
      const input = document.querySelector(
        'input[autocomplete="one-time-code"]'
      );
      if (!input) return;
      const ac = new AbortController();
      try {
        const otp = await navigator.credentials.get({
          otp: {
            transport: ["sms"],
          },
          signal: ac.signal,
        });
        input.value = otp.code;
        // setInputs((inputs) => ({ ...inputs, otp: otp.code }));
        setTimeout(verifyOtp(mobile, otp.code), 5000);
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
  };

  const verifyOtp = async (e) => {
    // debugger;
    if (!mobileNo) {
      alert("please enter mobile number");
      return;
    }

    const OTP = otp1 + otp2 + otp3 + otp4 + otp5 + e.target.value;
    //console.log(fullOtp);
    if (OTP.length == 6) {
      try {
        let payload = { mobile: mobileNo, otp: OTP };
        let param = { otp: "verify", productType: "BG" };
        const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
        // const res = await onVerifyOtp(mobileNo, OTP);
        if (
          otpVerifyResponse.data.message ===
          "Failure Occured, please check logs"
        ) {
          setotp1("");
          setotp2("");
          setotp3("");
          setotp4("");
          setotp5("");
          setotp6("");
          const nextfield = document.querySelector(`input[name=field-1]`);

          // If found, focus the next field
          if (nextfield !== null) {
            nextfield.focus();
          }
          notifyWarn("Please enter valid OTP");
          return false;
        } else {
          notifySuccess("OTP Verified");
          const tokenValue =
            otpVerifyResponse.data.message.response.dataSent.UniqueID;
          setOTPValue(OTP);
          setToken(tokenValue);
          setOtpVerified(true);
          formIntermediateEventOTP("verified");
          setSeconds(0);
        }
      } catch (error) {
        console.log("error in verify OTP", error)
      }
    }
  };

  /**
   * this fn will take pincode and set options for branches to display on UI
   * @param {*} pincode
   */
  async function handleChangePIN(e) {
    handleChange(e);
    const PIN = e.target.value;
    setpincode(PIN);
    if (PIN.length < 6) {
      validPincodeRef.current = null;
      return;
    }
    try {
      const payload = { pincode: PIN };
      const param = { type: "SalCorpPincode" };
      const response = await callLSQLapp(payload, "MAVIS", param);
      if (response.data.message.Count === 0) {
        validPincodeRef.current = false;
        fieldErrorEvent("Please enter valid pincode.", "pincode");
        setErrors({
          pincodeerror: {
            error: true,
            message: "Enter valid pincode",
            type: "required",
          },
        });
        setOptions([]);
        setInputs((prev) => ({
          ...prev,
          Branch_Name: "",
          City: "",
          State: "",
          State2: "",
        }));
      } else {
        validPincodeRef.current = true;
        setErrors({
          pincodeerror: { error: false, message: "", type: "required" },
        });
        setOptions(response.data.message.Data);
        setSolid(response.data.message.Data[0].Sol_ID);
        setInputs((prev) => ({
          ...prev,
          Branch_Name: response.data.message.Data[0].Branch_Name,
          City: response.data.message.Data[0].City,
          State: response.data.message.Data[0].State,
          State2: response.data.message.Data[0].State2,
        }));
      }
    } catch (err) {
      console.error("Pincode validation failed:", err);
    }
  }

  // Logger Effect
  // useEffect(() => {
  //   console.log("inputs", inputs);
  // }, [inputs]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

  const handlePANChange = (e) => {
    handleChange(e)
    let value = e.target.value;

    value = value.replace(/\s\s+/g, " ");
    value = value.toUpperCase();
    value = value.replace(/[^a-zA-Z0-9]/g, "");

    if (value.length <= 5 && /[^a-zA-Z]/.test(value)) {
      value = value.slice(0, -1);
    }

    if (
      value.length > 5 &&
      value.length <= 9 &&
      /^[^0-9]+$/.test(value.slice(5, 9))
    ) {
      value = value.slice(0, -1);
    }

    if (value.length === 10 && /^[^a-zA-Z]/.test(value.slice(-1))) {
      value = value.slice(0, -1);
    }

    setPanNum(value);
  };

  const handleBlur = async (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "email") {
      //regular expression for email validation
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (value) {
        setErrors({
          workEmailerror: {
            error: false,
            message: "",
            type: "",
          },
        });
      }
      if (!value) {

        setErrors({
          workEmailerror: {
            error: true,
            message: "Please enter your email.",
            type: "required",
          },
        });
        fieldErrorEvent("Please enter your email.", "email");
        // setemail("Please enter your email.");
      } else if (typeof value !== "undefined" && !pattern.test(value)) {
        setErrors({
          workEmailerror: {
            error: true,
            message: "Please enter valid email.",
            type: "required",
          },
        });
        fieldErrorEvent("Please enter valid email.", "email");
        // setemail("Please enter valid email.");
      } else {
        //   // const caseId = generateCaseId();
        //   // payload for testing email verification api
        //   const payload = {
        //     email: workEmail,
        //     individualName: fullName,
        //     organizationName: employerName,
        //     consent: "Y",
        //     // clientData: {
        //     //   caseId: caseId,
        //     // },
        //   };
        //   const emailVerify = await callLSQLapp(payload, "KARZA_MAIL", {
        //     requestType: "verify_email",
        //   });
        //   setCaseID(emailVerify?.data?.message?.clientData.caseId)
        //   if (emailVerify?.data?.message?.result?.result === true) {
        //     setEmailVerified(true);

        //     // alert("email verified");
        //     notifySuccess("Email Verified Successfully")
        //     setErrors({
        //       workEmailerror: { error: false, message: "", type: "" },
        //     });
        //   } else if (emailVerify?.data?.message?.error) {
        //     setEmailVerified(false);
        //     // notifyWarn("Please enter a valid email to continue");
        //     // setErrors({
        //     //   workEmailerror: {
        //     //     error: true,
        //     //     message: "In-valid Work email id",
        //     //     type: "required",
        //     //   },
        //     // });
        //   } else {
        //     setEmailVerified(false);
        //     // notifyWarn("Please enter a valid email to continue");

        //     // setErrors({
        //     //   workEmailerror: {
        //     //     error: true,
        //     //     message: "In-valid Work email id",
        //     //     type: "required",
        //     //   },
        //     // });
        //   }
      }
    }
    if (name === "pan") {
      if (!panNum) {
        setpan("Please enter your pan number.");
        fieldErrorEvent("Please enter your pan number.", "pan")

      } else {
        if (!panNum.match(regpan)) {
          setpan("Please enter valid pan number.");
          fieldErrorEvent("Please enter valid pan number.", "pan")
        } else {
          setpan("");
        }
      }
    }


    if (name === "pincode") {
      const pincode_reg = /^[1-9][0-9]{5}$/;

      if (!value) {
        setErrors({
          pincodeerror: {
            error: true,
            message: "Please enter valid pincode",
            type: "required",
          },
        });
      } else if (!value.match(pincode_reg) || validPincodeRef.current === false) {
        setErrors({
          pincodeerror: {
            error: true,
            message: "Enter valid pincode",
            type: "required",
          },
        });
        fieldErrorEvent("Enter valid pincode.", "pincode");
      } else {
        setErrors({
          pincodeerror: { error: false, message: "", type: "required" },
        });
      }
    }

    if (name === "fullName") {

      const name_reg = /^[a-zA-Z ]*$/;
      if (value) {
        if (!value.match(name_reg)) {
          setErrors({
            fullnameerror: {
              error: true,
              message: "enter a valid name",
              type: "required",
            },
          });
        } else {
          setErrors({
            fullnameerror: {
              error: false,
              message: "",
              type: "required",
            },
          });
        }
      } else {
        setErrors({
          fullnameerror: {
            error: true,
            message: "enter a valid name",
            type: "required",
          },
        });
      }
    }

    if (name === "mobileNo") {

      const mobile_reg = /^[6-9]{1}[0-9]{9}$/;
      if (value) {
        if (!value.match(mobile_reg)) {
          setErrors({
            mobilenoerror: {
              error: true,
              message: "enter a valid phone number",
              type: "required",
            },
          });
        } else {
          setErrors({
            mobilenoerror: {
              error: false,
              message: "",
              type: "required",
            },
          });
        }
      } else {
        setErrors({
          mobilenoerror: {
            error: true,
            message: "enter a valid phone number",
            type: "required",
          },
        });
      }
    }
    // if (name === "city") {

    //   const name_reg = /^[a-zA-Z ]*$/;
    //   if (value) {

    //     setErrors({
    //       cityerror: {
    //         error: false,
    //         message: "",
    //         type: "required",
    //       },
    //     });

    //   } else {
    //     setErrors({
    //       cityerror: {
    //         error: true,
    //         message: "enter a valid city",
    //         type: "required",
    //       },
    //     });
    //   }
    // }
  };

  const ValidateForm = async () => {
    let result = true;
    const errors = {};
    const errorFieldNames = [];

    if (!fullName) {
      errors.fullnameerror = {
        error: true,
        message: "Please enter Name",
        type: "required",
      };
      errorFieldNames.push("fullName");
      result = false;
    } else {
      errors.fullnameerror = { error: false, message: "", type: "" };
    }


    if (!employerName) {
      errors.employerNameerror = {
        error: true,
        message: "Please enter Employer Name",
        type: "required",
      };
      errorFieldNames.push("employerName");
      result = false;
    } else {
      errors.employerNameerror = { error: false, message: "", type: "" };
    }



    if (employerName == "Others" && !otherCompanyName) {

      errors.othercompanyerror = {
        error: true,
        message: "Please enter other Employer Name",
        type: "required",
      };
      errorFieldNames.push("otherCompanyName");
      result = false;
    } else {
      errors.othercompanyerror = { error: false, message: "", type: "" };
    }

    if (employerName == "Others" && !annualIncome) {
      errors.incomeerror = {
        error: true,
        message: "Please select Annual Income",
        type: "required",
      };
      errorFieldNames.push("annualIncome");
      result = false;
    } else {
      errors.incomeerror = { error: false, message: "", type: "" };
    }

    if (!workEmail) {
      errors.workEmailerror = {
        error: true,
        message: "Please enter Work email id",
        type: "required",
      };

      errorFieldNames.push("workEmail");
      result = false;
    } else {
      const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      if (!workEmail.match(isValidEmail)) {
        errors.workEmailerror = {
          error: true,
          message: "In-valid Work email id",
          type: "required",
        };

        errorFieldNames.push("workEmail");
        result = false;
      } else {
        errors.workEmailerror = { error: false, message: "", type: "" };
      }
    }

    if (!mobileNo) {
      errors.mobilenoerror = {
        error: true,
        message: "Please enter Mobile No",
        type: "required",
      };
      errorFieldNames.push("mobileNo");
      result = false;
    } else if (mobileNo.length !== 10) {
      errors.mobilenoerror = {
        error: true,
        message: "Please enter correct mobile no",
        type: "required",
      };
      errorFieldNames.push("mobileNo");
      result = false;
    } else {
      errors.mobilenoerror = { error: false, message: "", type: "" };
    }

    if (!pincode) {
      errors.pincodeerror = {
        error: true,
        message: "Please enter Pincode",
        type: "required",
      };
      errorFieldNames.push("pincode");
      result = false;
    } else if (pincode.length !== 6) {
      errors.pincodeerror = {
        error: true,
        message: "Please enter correct pincode",
        type: "required",
      };
      errorFieldNames.push("pincode");
      result = false;
    } else if (validPincodeRef.current !== true) {
      errors.pincodeerror = {
        error: true,
        message: "Enter valid pincode",
        type: "required",
      };
      errorFieldNames.push("pincode");
      result = false;
    } else {
      errors.pincodeerror = { error: false, message: "", type: "" };
    }



    if (!Terms) {
      errors.termserror = {
        error: true,
        message: "Please accept terms",
        type: "required",
      };
      errorFieldNames.push("Terms");
      result = false;
    } else {
      errors.termserror = { error: false, message: "", type: "" };
    }

    if (!panNum) {
      errors.panerror = {
        error: true,
        message: "Please enter PAN",
        type: "required",
      };
      errorFieldNames.push("PAN");
      result = false;
    } else {
      errors.panerror = { error: false, message: "", type: "" };
    }

    setErrors(errors);


    if (!result) {

      const errorObj = {}
      for (let key in errors) {
        if (errors[key]["error"] === true) {
          errorObj[key.replace('error', '')] = errors[key]["message"]
        }
      }
      errorRef.current = { ...errorObj }

      // Focus the first error field
      const errorFields = [
        "fullName",
        "employer_name",
        "email",
        "mobileNo",
        "pincode",
        "city",
        "terms",
      ];

      for (const field of errorFields) {
        const errorFieldElement = document.querySelector(
          `input[name=${field}]`
        );
        if (
          errorFieldElement &&
          errors[`${field}error`] &&
          errors[`${field}error`].error
        ) {
          errorFieldElement.focus();
          break;
        }
      }
    }

    return result;
  };


  let lastFetchedPrefix = "";

  const onCompanyChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = searchValue.substring(0, 4).toLowerCase();
    const storageKey = `salCorp_${prefix}`;

    setEmployerName(inputValue);
    handleChange(e);

    const addOthersIfNeeded = (list) => {
      const hasExactMatch = list.some(
        (item) => item.Company_Name.toLowerCase() === searchValue.toLowerCase()
      );
      if (!hasExactMatch && searchValue.length > 0) {
        return [...list, { Company_Name: "Others", LTF: null }];
      }
      return list;
    };

    const storedData = localStorage.getItem(storageKey);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const filteredData = parsedData.filter((item) =>
        item.Company_Name.toLowerCase().includes(searchValue.toLowerCase())
      );
      const finalData = addOthersIfNeeded(filteredData);
      setCompanies(finalData);
    } else if (prefix.length >= 3 && prefix !== lastFetchedPrefix) {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Cancelled due to new request");
      }

      cancelToken = axios.CancelToken.source();

      try {
        const payload = { company: searchValue };
        const param = { type: "salCorpGCC" };

        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;

        if (Count > 0) {
          localStorage.setItem(storageKey, JSON.stringify(Data));
          lastFetchedPrefix = prefix;

          const filteredData = Data.filter((item) =>
            item.Company_Name.toLowerCase().includes(searchValue.toLowerCase())
          );
          const finalData = addOthersIfNeeded(filteredData);
          setCompanies(finalData);
        } else {
          lastFetchedPrefix = prefix;
          setCompanies([{ Company_Name: "Others", LTF: null }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Company fetch failed:", error);
        }
      }
    } else {
      setCompanies([]);
    }

    const hasExactMatchInDropdown = companies.some(
      (item) => item.Company_Name.toLowerCase() === searchValue.toLowerCase()
    );

    if (searchValue.length >= 3 && !hasExactMatchInDropdown) {
      setShowOtherInput(true);
      setValue("companyName", "Others");
      setValue("otherCompanyName", inputValue);
      setGcc("Others");
    } else {
      setShowOtherInput(false);
    }

  };


  const onFullnameChange = (e) => {
    const re = /^[a-zA-Z\s]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setfullname(e.target.value);
    }
  };

  const handleChange = (e) => {
    setCustomADL({ ...customADL, formStarts: Date.now() });
    if (!formStarted) {
      formStarts();
      setCustomADL({ ...customADL, formStarts: Date.now() });
      setFormStarted(true);
    }
    // debugger;
    const { maxLength, value, name } = e.target;


    const otpFields = ["field-1", "field-2", "field-3", "field-4", "field-5", "field-6"]
    if (otpFields.includes(name)) {
      const [fieldName, fieldIndex] = name.split("-");

      let fieldIntIndex = parseInt(fieldIndex, 10);

      // Check if no of char in field == maxlength
      if (value.length >= maxLength) {
        // It should not be last input field
        if (fieldIntIndex < 6) {
          // Get the next input field using it's name
          const nextfield = document.querySelector(
            `input[name=field-${fieldIntIndex + 1}]`
          );

          // If found, focus the next field
          if (nextfield !== null) {
            nextfield.focus();
          }
        }
      }

    }

    // we are setting solID here against the branchName
    if (name === "city") {
      const selectedOptionSolid =
        e.target.options[e.target.selectedIndex].getAttribute("solid");
      setSolid(selectedOptionSolid.toString());
      setcity(e.target.value);
    }
  };

  const onSubmitForm = async (obj) => {
    setSubmitted(true);
    const isValid = await ValidateForm();
    console.log(isValid)
    if (isValid) {
      const pincodeData = inputs;
      if (otpVerified) {
        console.log("employerName", employerName)
        const finalEmployerName = employerName?.trim().toLowerCase() === "others" ? otherCompanyName : employerName;
        const annualSalary = employerName?.trim().toLowerCase() === "others" ? annualIncome.replace(/,/g, "") : ""
        // GCC check
        const employerIsOthers =
          employerName?.trim().toLowerCase() === "others";
        const isGcc = employerIsOthers
          ? "Others"
          : gcc || "Others";

        //topcorporate
        const isTopCorporate = employerName?.trim().toLowerCase() !== "others" ? "yes" : "no";
        // const corporateTypes =
        //   employerName?.trim().toLowerCase() === "others"
        //     ? "Others"
        //     : gcc === "GCC" || ""
        //       ? "GCC"
        //       : "Top Corporate";    // settopCorporate(isTopCorporate);
        console.log(isTopCorporate);

        setApplyBtnDisable(true);
        const { firstName, lastName } = getFirstNameLastName(fullName);
        let inputs = {
          name: fullName,
          firstname: firstName,
          lastname: lastName,
          fullName: fullName,
          employerName: finalEmployerName,
          workEmail: workEmail,
          mobile: mobileNo,
          pincode: pincode,
          // CityName: document.getElementById("branch").value,
          otp: OTPVal,
          CampaignId: "832997",
          CompleteUrl: window.location.href,
          ApiProductName: "SalCorp Savings Account",
          FBPixelID: fbp,
          FBClickID: fbc,
          subProduct: "SalCorp",
          source: "Landing Page",
          isChecked: Terms,
          token: token,
          solId: solId,
          pan: panNum,
          interestedProduct: "Salary Account",
          // corporateType: corporateTypes,
          // journeyType: companies.length > 0 ? "Sal Corp UCJ" : "Call Centre assisted",
          email: workEmail || "",
          topCorporate: isTopCorporate,
          annualIncome: annualSalary,
          gcc: isGcc,
          Branch_Name: pincodeData.Branch_Name || "",
          City: pincodeData.City || "",
          State: pincodeData.State || "",
          State2: pincodeData.State2 || "",
        };

        // GET UTM DETAILS
        const utmParamsObj = queryString.parse(window.location.search);
        for (const [key, value] of Object.entries(utmParamsObj)) {
          inputs[key] = value;
        }

        let lsqInputs = getLsqLeadBody(inputs);
        // console.log("lsqInputs", lsqInputs)
        let payload = {
          mobile: inputs.mobile,
          otp: inputs.otp,
          formdata: lsqInputs,
        };


        let param = { productType: "BG" };


        const encryptedPayload = await encryptBody(payload);

        const createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);
        // console.log("payload", payload);


        // ? IF Lead Created
        if (
          createLeadResp.data.message !== "Failure occured , please check logs"
        ) {
          let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
          if (inputs.mobile && inputs.workEmail) {
            const formattedMobile = formatAndValidateE164(inputs.mobile);
            const hashedMobile = await hashValue(formattedMobile);
            const formatedEmail = normalizeEmail(inputs.workEmail);
            const hashedEmail = await hashValue(formatedEmail)
            setValuesInLocalStorange("userData", hashedEmail, hashedMobile);
          }


          navigate(`thankyou?id=${leadid}`);
          formSubmitEvent(inputs, true)

          // console.log("redirect", redirect);
          // if (

          //   companies.length === 0 ||
          //   emailVerified === false
          // ) {
          //   navigate(`/thank-you-cc-assist?id=${leadid}`);
          //   formSubmitEvent(inputs, false);
          // } else {
          //   navigate(`thank-you-ucj?id=${leadid}`);
          //   formSubmitEvent(inputs, true);
          // }
        } else {
          setApplyBtnDisable(false);
          console.log("lead not created.");
          formSubmissionFailEvent();
          // console.log(window.adobeDataLayer || []);
          window.alert("Some error occured! Please try again after some time.");
          // window.location.reload();
        }
      } else {
        if (otpStatus == false) {
          setOtpVerified(false);
          setErrors({
            mobilenoerror: {
              error: true,
              message: "Please Verify mobile no with OTP",
              type: "required",
            },
          });
          return;
        }
      }
    } else {
      submitErrorEvent(errorRef.current);
    }
  };

  // const onCompanySelect = (companyName) => {
  //   setEmployerName(companyName);
  //   setShowDropdown(false);
  // };
  // const onCityChange = (e) => {
  //   const re = /^[a-zA-Z\s]+$/;
  //   if (e.target.value === "" || re.test(e.target.value)) {
  //     console.log(e.target.value)
  //     setcity(e.target.value);
  //   }
  // };

  return (

    <article className="banner_section position-relative  null">
      {/* <button onClick={() => {navigate('/thankyou')}}>
      NAVIGATE TO TY
      </button> */}
      <div className="banner_img">
        <picture>
          <source
            rel="preload"
            srcSet="./dist/img/salCorp_banner_mob.webp"
            media="(max-width:480.5px)"
            alt="ICICI Bank saving account banner"
            width={480}
            height={360}
            className="img-fluid "
            fetchpriority="high"
          />
          <source
            rel="preload"
            srcSet="./dist/img/salCorp_banner_ipad.webp"
            media="(max-width:768.5px)"
            alt="ICICI Bank saving account banner"
            width={768}
            height={576}
            className="img-fluid"
            fetchpriority="high"
          />
          <img
            rel="preload"
            src="./dist/img/salCorp_banner_desk.webp"
            alt="ICICI Bank saving account banner"
            width={2560}
            height={867}
            className="img-fluid"
            fetchpriority="high"
          />
        </picture>
        {isMobile && <div className="orange--band">
          <a href="#saving_account">Get your account now</a>
        </div>}
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-12">
            <div className="form_wrap" id="saving_account">
              <div className="form_heading">
                <h4>
                  All this and more with the <br />
                  ICICI Bank Salary Account


                </h4>
              </div>

              <form name="contactForm" noValidate>
                <section className="personal-details">
                  <div className="col-12 my-2">
                    <div className="row">
                      <div className="col-12 my-2">
                        <input
                          type="text"
                          name="fullName"
                          placeholder="Name (as per PAN)"
                          id="fullName"
                          className=""
                          value={fullName}
                          onChange={(e) => {
                            onFullnameChange(e);
                            handleChange(e)
                          }
                          }
                          onBlur={handleBlur}
                        />
                        {Validtionerrors.fullnameerror ? (
                          <>
                            {Validtionerrors.fullnameerror?.type ===
                              "required" && (
                                <span className="error-msg">
                                  {Validtionerrors.fullnameerror?.message}
                                </span>
                              )}
                          </>
                        ) : null}
                      </div>
                      <div className="col-12 my-2">
                        <input
                          type="text"
                          name="pan"
                          placeholder="PAN"
                          id="pan"
                          value={panNum || ""}
                          onChange={handlePANChange}
                          onBlur={handleBlur}
                          onInput={(e) =>
                            (e.target.value = e.target.value.slice(0, 10))
                          }
                        />
                        {pan !== "" ? (
                          <span
                            style={{
                              fontSize: "12px",
                              fontFamily: "sans-serif",
                              fontStretch: "normal",
                              fontStyle: "12px",
                              fontWeight: 400,
                              lineHeight: "normal",
                              letterSpacing: "normal",
                              left: "15px",
                              bottom: 0,
                              color: "red",
                            }}
                          >
                            {pan}
                          </span>
                        ) : null}
                        {Validtionerrors.panerror ? (
                          <>
                            {Validtionerrors.panerror?.type ===
                              "required" && (
                                <span className="error-msg">
                                  {Validtionerrors.panerror?.message}
                                </span>
                              )}
                          </>
                        ) : null}

                      </div>
                      <div className="col-12 my-2">

                        <input
                          type="text"
                          name="employer_name"
                          placeholder="Employer name (Type 3+ chars for suggestions)"
                          id="employer_name"
                          value={employerName}
                          onBlur={handleBlur}
                          onChange={(e) => { onCompanyChange(e); handleChange(e) }}
                        // disabled={emailVerified}
                        />

                        {showDropdown && companies.length > 0 && (
                          <ul className="company-dropdown">
                            {companies.map((item) => (
                              <li
                                className="company-List"
                                key={item.Company_Name}
                                onClick={() => {
                                  if (item.Company_Name === "Others") {
                                    setShowOtherInput(true);
                                    setEmployerName("Others");
                                    setValue("annualIncome", "")
                                    clearErrors("annualIncome");
                                    setOtherCompanyName("");
                                    setValue("otherCompanyName", "");
                                    clearErrors("otherCompanyName");
                                  } else {
                                    setEmployerName(item.Company_Name);
                                    setGcc(item.GCC)
                                    setShowOtherInput(false);
                                  }
                                  setCompanies([]);
                                  setValue("companyName", item.Company_Name);
                                }}
                              >
                                {item.Company_Name}
                              </li>
                            ))}
                          </ul>
                        )}

                        {showOtherInput && (
                          <>
                            <div className="col-12 my-2">
                              <input
                                className="input-box"
                                type="text"
                                name="OtherCompany"

                                placeholder="Enter Other Employer Name"
                                value={otherCompanyName}
                                onChange={(e) => {
                                  setOtherCompanyName(e.target.value)
                                }}

                              />




                              {Validtionerrors.othercompanyerror ? (
                                <>
                                  {Validtionerrors.othercompanyerror?.type ===
                                    "required" && (
                                      <span className="error-msg">
                                        {Validtionerrors.othercompanyerror?.message}
                                      </span>
                                    )}
                                </>
                              ) : null}
                            </div>

                            <div className="">
                              {/* Add your Annual Salary or other field here */}
                              {/* <select
                      id="annualincome"
                      defaultValue=""
                      className="col-12 my-2"
                      {...register("annualIncome")}
                    >
                      <option value="" disabled>
                        Annual Income
                      </option>
                      <option value="Below 40,000">Below 40,000</option>
                      <option value="40,000-50,000">
                        ₹40,000-₹50,000
                      </option>
                      <option value="50,000 and above">
                        ₹50,000 and above
                      </option>
                    </select> */}

                              <input
                                id="annualincome"
                                type="text"
                                className="col-12 my-2"
                                placeholder="Take home salary per month"
                                {...register("annualIncome")}
                                onChange={(e) => {
                                  let rawValue = e.target.value.replace(/,/g, ""); // remove commas

                                  // Block non-numeric input
                                  rawValue = rawValue.replace(/[^0-9]/g, "");

                                  // Prevent leading 0
                                  if (rawValue.startsWith("0")) {
                                    rawValue = rawValue.slice(1);
                                  }

                                  if (rawValue) {
                                    // Format to ₹ style: 100000 -> 1,00,000
                                    e.target.value = Number(rawValue).toLocaleString("en-IN");
                                  } else {
                                    e.target.value = "";
                                  }
                                }}
                                onKeyDown={(e) => {
                                  // Allow only numbers and control keys
                                  const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
                                  if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {Validtionerrors.incomeerror ? (
                                <>
                                  {Validtionerrors.incomeerror?.type ===
                                    "required" && (
                                      <span className="error-msg">
                                        {Validtionerrors.incomeerror?.message}
                                      </span>
                                    )}
                                </>
                              ) : null}
                            </div>
                          </>
                        )}


                        {Validtionerrors.employerNameerror ? (
                          <>
                            {Validtionerrors.employerNameerror?.type ===
                              "required" && (
                                <span className="error-msg">
                                  {Validtionerrors.employerNameerror?.message}
                                </span>
                              )}
                          </>
                        ) : null}
                      </div>
                      <div className="col-12 my-2">
                        <input
                          // data-tooltip-id="my-tooltip"
                          // data-tooltip-content="To ensure a smooth and quick processing of your application, we recommend providing work email ID"
                          // data-tooltip-place="top"
                          type="text"
                          name="email"
                          placeholder="Email Id"
                          id="email"
                          value={workEmail}
                          onChange={(e) => { setworkEmail(e.target.value); handleChange(e) }}
                          onBlur={handleBlur}
                        // disabled={emailVerified || (!employerName || !fullName)}
                        />
                        {Validtionerrors.workEmailerror ? (
                          <>
                            {Validtionerrors.workEmailerror?.type ===
                              "required" && (
                                <span className="error-msg">
                                  {Validtionerrors.workEmailerror?.message}
                                </span>
                              )}
                          </>
                        ) : null}
                      </div>
                      <Tooltip id="my-tooltip" />
                      <div className="my-2">
                        <span className="position-relative ">
                          <span className=" number-span ">+91 </span>
                          <input
                            type="number"
                            maxLength={10}
                            pattern="\d{10}"
                            className="errBrdr mobile--number"
                            style={{ textAlign: "left", paddingLeft: "35px" }}
                            placeholder="Mobile No.*"
                            id="mobileNo"
                            name="mobileNo"
                            disabled={otpVerified}
                            onChange={(e) => {
                              if (e.target.value.length <= 10) {
                                setmobileno(e.target.value);
                                setOtpVerified(false);
                              };
                              handleChange(e);
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length >= 10 &&
                                e.key !== "Backspace" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onBlur={handleBlur}
                          />
                          {Validtionerrors.mobilenoerror ? (
                            <>
                              {Validtionerrors.mobilenoerror?.type ===
                                "required" && (
                                  <span className="error-msg">
                                    {Validtionerrors.mobilenoerror?.message}
                                  </span>
                                )}
                              {Validtionerrors.mobilenoerror?.type ===
                                "minLength" && (
                                  <span className="error-msg">
                                    {Validtionerrors.mobilenoerror?.message}
                                  </span>
                                )}
                            </>
                          ) : null}
                          {!otpVerified && (
                            <div className="otpbtn">
                              {otpStatus == false && seconds == 0 && (
                                <button
                                  // disabled={emailVerified ? false : true}
                                  className="resend--otp"
                                  type="button"
                                  onClick={() => sendOtp("send")}
                                >
                                  Send OTP
                                </button>
                              )}
                              {otpStatus == true && seconds == 0 && (
                                <button
                                  className="resend--otp"
                                  type="button"
                                  onClick={() => sendOtp("resend")}
                                >
                                  Resend OTP
                                </button>
                              )}
                            </div>
                          )}
                        </span>
                      </div>
                      {otpStatus == true && seconds != 0 && (
                        <div className=" align-items-center w-100 mt-1">
                          <div className="row">
                            <div className="col-6 text-right">
                              <label
                                className="otp--label"
                                htmlFor="_otp_mobile"
                              >
                                Enter OTP received on
                                <br /> your mobile no
                              </label>
                            </div>
                            <div className="col-6 col-md-6">
                              <div className="otp-input-fields">
                                <input
                                  type="number"
                                  maxLength={1}
                                  value={otp1}
                                  name="field-1"
                                  className="otp__digit otp__field__1 otp__mobile"
                                  onChange={(e) => {
                                    setotp1(e.target.value);
                                    handleChange(e);
                                  }}
                                />
                                <input
                                  type="number"
                                  maxLength={1}
                                  value={otp2}
                                  name="field-2"
                                  className="otp__digit otp__field__2 otp__mobile"
                                  onChange={(e) => {
                                    setotp2(e.target.value);
                                    handleChange(e);
                                  }}
                                />
                                <input
                                  type="number"
                                  maxLength={1}
                                  value={otp3}
                                  name="field-3"
                                  className="otp__digit otp__field__3 otp__mobile"
                                  onChange={(e) => {
                                    setotp3(e.target.value);
                                    handleChange(e);
                                  }}
                                />
                                <input
                                  type="number"
                                  maxLength={1}
                                  value={otp4}
                                  name="field-4"
                                  className="otp__digit otp__field__4 otp__mobile"
                                  onChange={(e) => {
                                    setotp4(e.target.value);
                                    handleChange(e);
                                  }}
                                />
                                <input
                                  type="number"
                                  maxLength={1}
                                  value={otp5}
                                  name="field-5"
                                  className="otp__digit otp__field__5 otp__mobile"
                                  onChange={(e) => {
                                    setotp5(e.target.value);
                                    handleChange(e);
                                  }}
                                />
                                <input
                                  type="number"
                                  maxLength={1}
                                  value={otp6}
                                  name="field-6"
                                  className="otp__digit otp__field__6 otp__mobile"
                                  onChange={(e) => {
                                    setotp6(e.target.value);
                                    verifyOtp(e);
                                  }}
                                />
                                <input
                                  type="hidden"
                                  id="_otp_mobile"
                                  className="_notok"
                                />
                              </div>
                              <span className="Timer" id="timer">
                                00 : {seconds < 10 ? `0${seconds}` : seconds}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-6 my-2">
                        <div className="autocomplete">
                          <input
                            className=""
                            type="number"
                            min="0"
                            placeholder="Office Pincode"
                            id="pincode"
                            maxLength={6}
                            name="pincode"
                            value={pincode}
                            onInput={(e) =>
                              (e.target.value = e.target.value.slice(0, 6))
                            }

                            onChange={handleChangePIN}
                            onBlur={handleBlur}
                            // onChange={(e) => setpincode(e.target.value)}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length >= 6 &&
                                e.key !== "Backspace" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {Validtionerrors.pincodeerror ? (
                            <>
                              {Validtionerrors.pincodeerror?.type ===
                                "required" && (
                                  <span className="error-msg">
                                    {Validtionerrors.pincodeerror?.message}
                                  </span>
                                )}
                            </>
                          ) : null}
                        </div>
                      </div>
                      {/* <div className="col-6 my-2">
                        <div className="autocomplete">
                          
                          <select
                            name="city"
                            id="branch"
                            placeholder="city"
                            value={city}
                            onChange={handleChange}
                            onBlur={handleBlur}

                          >
                            <option value="" disabled>
                              City
                            </option>
                            {options.map((option) => (
                              <option
                                key={option.SOL_ID}
                                value={option.Branch_Name}
                                solid={option.SOL_ID}
                              >
                                {option.Branch_Name}
                              </option>
                            ))}
                          </select>
                          {Validtionerrors.cityerror ? (
                            <>
                              {Validtionerrors.cityerror?.type ===
                                "required" && (
                                  <span className="error-msg">
                                    {Validtionerrors.cityerror?.message}
                                  </span>
                                )}
                            </>
                          ) : null}
                        </div>
                      </div> */}

                      {/* {employerName && companies.length != 0 && emailVerified && (
                          <div className="account-option">
                            <p>I want to open:</p>

                            <div className="radio-btns">
                              <input
                                name="account-type"
                                type="radio"
                                value="Salary Account"
                                style={{ marginLeft: "3%" }}
                                checked={accountType == "Salary Account"}
                                onChange={(e) => setAccountType(e.target.value)}
                              />{" "}
                              <span>Salary Account</span>
                              <input
                                name="account-type"
                                type="radio"
                                value="Savings Account"
                                style={{ marginLeft: "21%" }}
                                checked = {accountType == "Savings Account"}
                                onChange={(e) => setAccountType(e.target.value)}
                              />{" "}
                              <span>Savings Account</span>
                            </div>
                          </div>
                        )} */}

                      <div className="checkbox row">
                        <div className="col-12">
                          <div className="form-check check-input">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="chkauthorize"
                              name="terms"
                              defaultChecked={Terms}

                              onChange={(e) => Onsetterms(e)}
                            />
                            <label className="form-check-label" htmlFor="chkauthorize">
                              I authorise ICICI Bank and its representatives to
                              contact me through phone, email, SMS and WhatsApp.
                              I also agree to ICICI Bank’s{" "}
                              <a
                                href="https://www.icicibank.com/content/dam/icicibank/india/managed-assets/docs/terms-condition/tnc-savings-account.pdf"
                                onClick={() => {
                                  eventWithFormInfo(
                                    "terms & conditions",
                                    "link",
                                    "form"
                                  );
                                }}
                                target="_blank"
                                rel="noreferrer"
                                onContextMenu={handleRightCLickTC}
                              >
                                {" "}
                                Terms &amp; Conditions
                              </a>
                              .
                            </label>
                          </div>
                        </div>
                        {Validtionerrors.termserror ? (
                          <>
                            {Validtionerrors.termserror?.type ===
                              "required" && (
                                <span className="error-msg">
                                  {Validtionerrors.termserror?.message}
                                </span>
                              )}
                          </>
                        ) : null}
                      </div>

                      <div className="applynow">
                        {/* <button
                            className="applybtn"
                            type="button"
                            onClick={handleSubmit(onSubmitForm)}
                          >
                            Apply Now
                          </button> */}

                        <button
                          className="applybtn"
                          type="button"
                          disabled={disableApplyBtn}
                          onClick={handleSubmit(onSubmitForm)}
                          style={{
                            backgroundColor: disableApplyBtn ? "grey" : "",
                          }}
                        >
                          {disableApplyBtn ? "Submitting..." : "Apply Now"}
                        </button>
                      </div>
                    </div>
                  </div>
                </section>
              </form>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </article>

  );
}

export default Form;
